import axios from "axios";

export interface Team {
  _id: string;
  name: string;
  shortName: string;
}

export interface TeamsSearchResponse {
  status: string;
  results: number;
  query: string;
  data: {
    teams: Team[];
  };
}

const API_BASE_URL = "/api/teams";

export const teamsApi = {
  // Search teams with query and limit
  search: async (
    query: string = "",
    limit: number = 5
  ): Promise<TeamsSearchResponse> => {
    const params = new URLSearchParams({
      limit: limit.toString(),
    });

    if (query.trim()) {
      params.append("query", query.trim());
    }

    const response = await axios.get(
      `${API_BASE_URL}/search?${params.toString()}`
    );
    return response.data;
  },
};
